import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpErrorInterceptor } from '@core/interceptors/http-error.interceptor';
import { SuccessInterceptor } from '@core/interceptors/success.interceptor';
import { DvCountriesService, DvPhoneInputService } from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthConfigModule } from './core/auth/auth-config.module';
import { HeaderInterceptor } from './core/interceptors/header.interceptor';
import { NoRightsComponent } from './pages/no-rights/no-rights.component';
import { PostLoginComponent } from './pages/post-login/post-login.component';
import { DvButtonComponent } from '@devinco/ui/dds';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    AppRoutingModule,
    DvButtonComponent,
    AuthConfigModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    NoRightsComponent,
    TranslateModule.forRoot({ defaultLanguage: 'no' }),
  ],
  declarations: [AppComponent, PostLoginComponent],
  bootstrap: [AppComponent],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
    DvCountriesService,
    DvPhoneInputService,
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: {
        usePopover: false,
      },
    },
  ],
})
export class AppModule {}
